<div class="alert alert-success" *ngIf="alertSuccess">
  Survey submitted successfully!
</div>
<div class="alert alert-danger" *ngIf="alertDuplicateSurvey">
  You have already taken the survey!
</div>
<div class="alert alert-danger" *ngIf="alertNoSurvey">
  There is no survey for this event!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
    {{timeoutErrorMessage}}
  </div>	
<form (ngSubmit)="confirm()" name="form" #myForm="ngForm" class="common-padding">
  <div class="takeSurveyTitle col-padding col-md-12 col-xs-12 col-sm-12 col-12">TAKE SURVEY</div>

  <div class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding takeSurveyQA" *ngFor="let question of questionsSelect; let i = index">
    <div [ngClass]="{'DisableRadio':DisableRadio}" class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding">
      <label class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding">
       {{i+1}} .{{question.surveyQuestion.question}} </label>
    </div>
    <div class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding" *ngFor="let answer of questionsAndAnswersModel">
      <div [ngClass]="{'DisableRadio':DisableRadio}" *ngIf="question.surveyQuestion.surveyQuestionId == answer.surveyQuestion.surveyQuestionId &&  (answer.surveyQuestion.answerType).trim() == 'SELECT' ">
        <label>
          <input type="radio" name="radio{{i}}" value="{{ answer.surveyAnswer.answerId }}" [(ngModel)]="selectedAnswer[i]"
          >
          <span class="label-text checkbox-style left"></span>
        </label><span >{{answer.surveyAnswer.answerText}}</span></div>
    </div>
  </div>

 <div class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding takeSurveyQA" *ngFor="let question of questionsText; let j = index">
    <div [ngClass]="{'DisableText1':DisableText}" class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding">
      <label class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding">
       {{questionsSelect.length + j +1}} .{{question.surveyQuestion.question}} </label>
    </div>
    <div class="col-md-12 col-xs-12 col-sm-12 col-12 col-padding" *ngFor="let answer of questionsAndAnswersModel">
      <span  [ngClass]="{'DisableText':DisableText}"  *ngIf="(question.surveyQuestion.surveyQuestionId == answer.surveyQuestion.surveyQuestionId && (answer.surveyQuestion.answerType).trim() == 'TEXT' )">       
          <textarea class="form-control col-md-6" rows="3" name="text{{j}}" value="" [(ngModel)] ="textAnswer[j]" ></textarea> 
        </span>
    </div>
  </div> 

  <div *ngIf="nameShow"> 
      <label class="optional_name_lbl">Your Name (Optional)</label>
      <input type="text" class="form-control col-md-6 optional_name" maxlength="100" name="optionalUserName"  [(ngModel)] ="optionalUserName">
  </div>  

  <div class="btn-div" *ngIf="nameShow">
    <button type="submit" class="btn btn-danger" [disabled]="!myForm.valid" data-toggle="modal" data-target="#myModal" [disabled]="alertSuccess">SUBMIT</button>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method]()" id="1"></app-confirmation-modal>
    <button type="button" class="btn btn-danger" (click)="cancel()" data-toggle="modal" data-target="#myModal"[disabled]="alertSuccess">CANCEL</button>
  </div>
</form>